import { attachDriver, Signal } from 'rwwa-rx-state-machine'
import * as signals from './signals'
import { TypedRecord, recordify } from 'typed-immutable-record'

export interface IQuaddiePageState {
  valueSelected: boolean
}

export interface IQuaddiePageStateRecord
  extends TypedRecord<IQuaddiePageStateRecord>,
    IQuaddiePageState {}

const defaultQuadie = recordify<IQuaddiePageState, IQuaddiePageStateRecord>({
  valueSelected: false,
})

function quaddieDriver(state = defaultQuadie, signal: Signal): IQuaddiePageStateRecord {
  switch (signal.tag) {
    case signals.ChangeQuaddieValue:
      return state.set('valueSelected', !state.valueSelected)
    default:
      return state
  }
}

export const quaddie$ = attachDriver<IQuaddiePageStateRecord>({
  path: 'racingform-quaddie',
  driver: quaddieDriver,
})
